import { render, staticRenderFns } from "./growthModelHisParamControlChart_1.vue?vue&type=template&id=53711fb0&scoped=true"
import script from "./growthModelHisParamControlChart_1.vue?vue&type=script&lang=js"
export * from "./growthModelHisParamControlChart_1.vue?vue&type=script&lang=js"
import style0 from "./growthModelHisParamControlChart_1.vue?vue&type=style&index=0&id=53711fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53711fb0",
  null
  
)

export default component.exports